import { deepCopy } from '@lhb/func';
import { useEffect, useState } from 'react';

function useSelctRowKeys(type = 'checkbox'): {
  selectedRowKeys: any[],
  onChange: (selectedRowKeys: any, selectedRows?: any) =>void,
  selectedRows: any,
  toggleSelectedRow: (row: any, rowKey: string) => void, // 切换单行的选中状态，传入 row 行数据、rowKey 行唯一键名
  prevSelectedRows: any } {
  const [selectedRowKeys, setSelectRowKeys] = useState<any[]>([]);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [prevSelectedRows, setPrevSelectedRows] = useState<any[]>([]);

  const onChange = (selectedRowKeys: any[], selectedRows: any[]) => {
    setSelectRowKeys(selectedRowKeys);
    setSelectedRows(selectedRows || []);
  };

  // 切换行的选中状态
  const toggleSelectedRow = (row: any, rowKey: string) => {
    const values = deepCopy(selectedRowKeys);
    const rows = deepCopy(selectedRows);

    const value = row[rowKey];
    const index = values.indexOf(value);
    if (type === 'checkbox') {
      if (index === -1) { // 未选中
        setSelectRowKeys(values.concat(value));
        setSelectedRows(rows.concat(row));
      } else { // 选中
        values.splice(index, 1);
        setSelectRowKeys(values);
        rows.splice(index, 1);
        setSelectedRows(rows);
      }
    } else if (type === 'radio') {
      setSelectRowKeys([row[rowKey]]);
      setSelectedRows([row]);
    }
  };

  useEffect(() => {
    return () => {
      setPrevSelectedRows(selectedRows || []);
    };
  }, [selectedRows]);

  return {
    selectedRowKeys,
    onChange,
    selectedRows,
    toggleSelectedRow,
    prevSelectedRows
  };
}

export default useSelctRowKeys;
